// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"176":"projects","443":"about"}[chunkId] + "." + {"176":"79f31a0c","443":"3523ff46"}[chunkId] + ".css";
};